import { Link } from 'react-router-dom';
import { Typography, styled } from '../../../../base';

export const BreadcrumbsContainer = styled('nav')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    fontSize: '14px',
    color: theme.palette.grey[600],
}));

export const BreadcrumbItemLink = styled(Link)(({ theme }) => ({
    textDecoration: 'none',
    color: theme.palette.grey[500],
    '&:hover': {
        textDecoration: 'underline',
    },
}));

export const BreadcrumbDivider = styled(Typography)(({ theme }) => ({
    margin: '0 8px',
    color: theme.palette.grey[500],
}));
